function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from 'react';
import defaultPropTypes from './prop-types';
export function renderComponents(className, elements, props) {
  var cloneProps = Object.assign({}, props);
  delete cloneProps.header;
  delete cloneProps.footer;
  return elements.length ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, elements.map(function (view) {
    return /*#__PURE__*/React.cloneElement(view, Object.assign({}, view.props, cloneProps));
  })) : '';
}
/**
 * function to make clickable URL to get directions from Google.
 * Accepts both location objects with lat and lng attributes or a string value for both origin and destination.
 *
 * @param {string|object} origin
 * @param {string|object} destination
 * @returns {string}
 */

export default function makeDirectionsUrl() {
  var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var destination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var baseUrl = 'https://www.google.com/maps/dir/?api=1';
  var params = '';

  if (_typeof(origin) === 'object' && Object.prototype.hasOwnProperty.call(origin, 'lat') && Object.prototype.hasOwnProperty.call(origin, 'lng')) {
    params = "".concat(params, "&origin=").concat(origin.lat, ",").concat(origin.lng);
  } else if (typeof origin === 'string' && origin !== '') {
    params = "".concat(params, "&origin=").concat(encodeURI(origin));
  }

  if (_typeof(destination) === 'object' && Object.prototype.hasOwnProperty.call(destination, 'lat') && Object.prototype.hasOwnProperty.call(destination, 'lng')) {
    params = "".concat(params, "&destination=").concat(destination.lat, ",").concat(destination.lng);
  } else if (typeof destination === 'string' && destination !== '') {
    params = "".concat(params, "&destination=").concat(encodeURI(destination));
  }

  return baseUrl + params;
}
export function withTempSelection(Component) {
  var clzz = /*#__PURE__*/function (_React$Component) {
    _inherits(WithHover, _React$Component);

    var _super = _createSuper(WithHover);

    function WithHover(props) {
      var _this;

      _classCallCheck(this, WithHover);

      _this = _super.call(this, props);
      _this.onMouseOver = _this.onMouseOver.bind(_assertThisInitialized(_this));
      _this.onMouseOut = _this.onMouseOut.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(WithHover, [{
      key: "onMouseOver",
      value: function onMouseOver() {
        this.props.onTempSelectLocation(this.props.location, 'select');
      }
    }, {
      key: "onMouseOut",
      value: function onMouseOut() {
        this.props.onTempSelectLocation(this.props.location, 'deselect');
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement("div", {
          onMouseOver: this.onMouseOver,
          onFocus: this.onMouseOver,
          onMouseOut: this.onMouseOut,
          onBlur: this.onMouseOut
        }, /*#__PURE__*/React.createElement(Component, this.props));
      }
    }]);

    return WithHover;
  }(React.Component);

  clzz.propTypes = {
    onTempSelectLocation: defaultPropTypes.func.isRequired,
    location: defaultPropTypes.location.isRequired
  };
  return clzz;
}